import { InObjectPropertyHelperBase } from './InObjectPropertyHelperBase';
export class InPropertyObjectPropertyHelper extends InObjectPropertyHelperBase {
    getObject(sb) {
        return sb.helpers.getPropertyObject;
    }
}

//# sourceMappingURL=InPropertyObjectPropertyHelper.js.map
